import React, { useState, useRef, useEffect } from "react";
import { Input, Form, Select, Button } from "Components";
import { useIntl } from "react-intl";
import { useSelector, useDispatch } from "react-redux";

//Hooks
import { useNewEntityTag, useTimeFrameComponent , useRealtimeUnits, useRealtimeDrivers} from 'Core/hooks';
import TimeFrame from "Modules/reports/views/main/components/reportsTab/.components/timeFrame/index.js";

// Helpers
import alertTypes from "Modules/alerts/common/alertTypes.json";

// Core
import { HasPermission } from "Core/security";

import { searchDashboardPanel } from "Redux/actions";

import "./recentAlerts.scss";
import TagsManage from "Modules/.common/components/TagsManage";

const DASHBOARD_RECENT_ALERTS_TAGS_TEST_ID = 'dashboard-recent-alerts-tags-test-id';

const CreateEditRecentAlerts = (props) => {
  const { onSubmit, handleClose } = props;
  const dispatch = useDispatch();
  const { messages, locale } = useIntl();
  const editCreateDashboardGadgets = useRef();
  const [formData, setFormData] = useState({});
  const [alertsSupported, setAlertsSupported] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);

  const { alertTypesSupported } = useSelector(
    (state) => state.alertsWizardRedux
  );
  const user = useSelector((state) => state.securityRedux.user);
  //const drivers = useRealtimeDrivers({ trackFields: ['id', 'name', 'externalId', 'disabled', 'tags'] });
  const units = useRealtimeUnits({ trackFields: ['id', 'name', 'label', 'disabled', 'driverId', 'vehicleStatusId', 'tags'] });
  const [showEntityTagPicker, setShowEntityTagPicker] = useState(false);

  const [itemsError, setItemsError] = useState(false);
  const [errorDates, setErrorDates] = useState(false);

  const ALL_EVENTS = {
    code: "-99",
    name: messages["dashboardPanel_recent_all_alerts_type"],
  };

  const { dashboard } = useSelector((state) => state.dashboardPanelRedux);

  const { preferencesUser } = useSelector((state) => state.preferencesRedux);

  const entityTags = useNewEntityTag(
    ["Unit", "Driver"],
    messages["dashboardPanel_recent_alerts_view_by"],
    "calc(100vh - 320px)",
    messages["dashboardPanel_recent_alerts_run_for"]
  );

  const optionsFrecuency = [
    {
      id: 300,
      name: `5 ${messages["dashboardPanel_edit_minutes"]}`,
    },
    {
      id: 900,
      name: `15 ${messages["dashboardPanel_edit_minutes"]}`,
    },
    {
      id: 1800,
      name: `30 ${messages["dashboardPanel_edit_minutes"]}`,
    },
    {
      id: 3600,
      name: `1 ${messages["dashboardPanel_edit_hours"]}`,
    },
    {
      id: 7200,
      name: `2 ${messages["dashboardPanel_edit_hours"]}`,
    },
  ];

  const timeFrameOptions = [
    { id: "today", label: messages["date_today"] },
    { id: "yesterday", label: messages["date_yesterday"] },
    { id: "week", label: `7 ${messages["Days"]}` },
    { id: "lastMonth", label: `30 ${messages["Days"]}` },
    { id: "custom", label: messages["date_custom"] },
  ];

  const timeFrame = useTimeFrameComponent(
    timeFrameOptions,
    null,
    true,
    "today"
  );

  useEffect(() => {
    dispatch(searchDashboardPanel());
  }, []);

  useEffect(() => {
    if (formData?.alertType) {
      if (timeFrame.option) {
        let option = timeFrameOptions.filter(
          (item) => item.id === timeFrame?.option.id
        )[0];
        timeFrame.onChangeSelect(
          option,
          timeFrame.startDate,
          timeFrame.endDate
        );
      }

      setFormData({
        ...formData,
        alertType:
          formData.alertType?.code == "-99" ? ALL_EVENTS : formData.alertType,
      });
    }
  }, [locale]);

  useEffect(() => {
    if (!gadGet.hasOwnProperty("name")) {
      let currentDashboard = null;
      const keyPreferences = "dashboard";
      let name = messages["dashboardPanel_edit_title_recent_alerts"];

      if (preferencesUser.length > 0) {
        let preferencesKeyTemp = preferencesUser?.find(
          (x) => x?.preferenceKey === keyPreferences
        );
        preferencesKeyTemp = preferencesKeyTemp
          ? JSON.parse(preferencesKeyTemp.preferenceValue)?.dashboardSelected
          : dashboard[0]?.id;
        let dashboardSelect = dashboard.filter(
          (dash) => dash.id === preferencesKeyTemp
        )[0];
        dashboardSelect = dashboardSelect ? dashboardSelect : dashboard[0];
        currentDashboard = dashboardSelect;
      } else if (dashboard.length > 0) {
        currentDashboard = dashboard[0];
      }

      if (currentDashboard?.gadgets?.length > 0) {
        let recentAlerts = currentDashboard.gadgets.filter(
          (gadGet) => gadGet.type === "RecentAlerts"
        );
        if (recentAlerts.length > 0) {
          let defaultRecentAlerts = recentAlerts.filter((gadGet) =>
            gadGet.name.includes(
              messages["dashboardPanel_edit_title_recent_alerts"]
            )
          );
          if (defaultRecentAlerts.length > 0) {
            let defaultRecentAlertsNames = defaultRecentAlerts.map(
              (gadGet) => gadGet.name
            );
            let count = 0;
            let done = false;
            while (!done && count <= 100) {
              if (
                !defaultRecentAlertsNames.includes(
                  `${messages["dashboardPanel_edit_title_recent_alerts"]}` +
                    (count ? " " + count : "")
                ) &&
                count != 1
              ) {
                name =
                  `${messages["dashboardPanel_edit_title_recent_alerts"]}` +
                  (count ? " " + count : "");
                done = true;
              }
              count++;
            }
          }
        }

        setFormData({
          ...formData,
          name,
        });
      }
    }
  }, [dashboard]);

  const { loadingCreateEdit, gadGet } = useSelector(
    (state) => state.dashboardPanelRedux
  );

  useEffect(() => {
    if (gadGet.hasOwnProperty("name")) {
      let settings = JSON.parse(gadGet.settings);

      if (settings?.entityTags?.entity)
        entityTags.onChangeEntity({ ...settings.entityTags.entity });
      if (settings?.entityTags?.option)
        entityTags.onOptionChange({ ...settings.entityTags.option });
      if (settings?.entityTags?.values)
        entityTags.onChange([...settings.entityTags.values]);

      if (
        settings?.timeFrame?.option &&
        settings?.timeFrame?.startDate &&
        settings?.timeFrame?.endDate
      ) {
        let option = timeFrameOptions.filter(
          (item) => item.id === settings.timeFrame?.option.id
        )[0];
        timeFrame.onChangeSelect(
          option,
          settings.timeFrame.startDate,
          settings.timeFrame.endDate
        );
      }

      setFormData({
        ...formData,
        alertType:
          settings?.alertType?.code == "-99" ? ALL_EVENTS : settings.alertType,
        name: gadGet.name,
        refreshSeconds: optionsFrecuency.filter(
          (frecuency) => frecuency.id === gadGet.refreshSeconds
        )[0],
      });
    } else {
      entityTags.onOptionChange({ id: "all", label: "All Units" });

      setFormData({
        ...formData,
        name: messages["dashboardPanel_edit_title_recent_alerts"],
        alertType: ALL_EVENTS,
        thresholdMinutes: 2,
      });
    }
    setShowEntityTagPicker(true);
  }, [open, gadGet]);

  const validateData = (e) => {
    if (!isSubmit) return false;

    if (entityTags.values?.length == 0 && entityTags.option?.id != "all") {
      setItemsError(true);
      return false;
    }

    if (entityTags.option?.id == "All") {
      entityTags.onChange([{ id: "-99", type: "Unit" }]);
    }

    let start = new Date(timeFrame.startDate);
    let end = new Date(timeFrame.endDate);
    if (start > end) {
      setErrorDates(true);
      return false;
    }

    onSubmit({
      ...formData,
      alertType: formData.alertType,
      entityTags: {
        option: { ...entityTags.option },
        values: [...entityTags.values],
        entity: { ...entityTags.entity },
      },
      timeFrame: {
        startDate: timeFrame.startDate,
        endDate: timeFrame.endDate,
        option: timeFrame.option,
      },
      refreshSeconds: 1800,
    });
  };

  useEffect(() => {
    if (isSubmit) {
      editCreateDashboardGadgets.current.submit();
      setIsSubmit(false);
    }
  }, [isSubmit]);

  useEffect(() => {
    if (alertTypesSupported) {
      let supported = [];
      supported = alertTypesSupported?.filter(
        (alert) =>
          alert.parentId == null && alertsSupported.includes(alert.code)
      );

      let validationQueclink = units?.some(
        (item) => item?.unitVersionProduct === "GL500MG"
      ); //&& process.env.ENVIROMENT === "production"

      if (!validationQueclink) {
        supported = supported?.filter((alert) => alert?.code !== "OnEvent");
      }

      alertTypes.map((alert) => supported.push(alert));
      let hiddenAlerts = ["OBDIIAlerts", "OBDII", "Geofence"]; // "FuelCard","HeavyDutyDTC", "LightDutyDTC"
      if (!HasPermission(user, "mediaalerts", "212")) {
        hiddenAlerts.push("Media");
      }
      if (!HasPermission(user, "fuel", [49])) {
        hiddenAlerts.push("FuelCard");
      }

      if (!HasPermission(user, "pFuelLev", [291])) {
        hiddenAlerts.push("FuelLevel");
      }

      supported = supported.filter((s) => !hiddenAlerts.includes(s.code));

      supported = supported.sort((a, b) => {
        if (
          a.name?.toString()?.toLowerCase() > b.name?.toString()?.toLowerCase()
        )
          return 1;
        if (
          b.name?.toString()?.toLowerCase() > a.name?.toString()?.toLowerCase()
        )
          return -1;
        return 0;
      });
      supported.unshift(ALL_EVENTS);

      setAlertsSupported(supported);
    }
  }, [alertTypesSupported, locale]);


  return (
    <div
      className={"recent-alert-form-container"}
      style={{
        padding: 20,
        paddingTop: 10,
        maxHeight: "77vh",
        overflow: "auto",
        marginTop: "-1rem",
      }}
    >
      <Form ref={editCreateDashboardGadgets} onValidSubmit={validateData}>
        <div style={{ paddingTop: 26 }}>
          <label className="title-section-form">
            {messages["dashboardPanel_gadget_name"]}
          </label>
          <Input
            id="name"
            value={formData.name || ""}
            onChange={(value) => {
              setFormData({ ...formData, name: value });
            }}
            minLength={1}
            maxLength={25}
            label={messages["dashboardPanel_gadget_name_instruction"]}
            placeholder={messages["dashboardPanel_gadget_name"]}
            type="text"
            requiredMessage={messages["required_field"]}
          />
        </div>
        <div className="recentAlert_dashboard" style={{ paddingTop: 26 }}>
          <label className="title-section-form">
            {messages["reportsMainRT_timeFrame"]}
          </label>
          <TimeFrame
            {...timeFrame}
            placeholder={messages["reportsMainRT_timeFrame"]}
            label={messages["reportsMainRT_selectTimeFrame"]}
            loading={loadingCreateEdit}
            required
            requiredMessage={messages["required_field"]}
            type={"rangemodaltimepicker"}
            classNameDate={"report-setup-time-vertical"}
            titleStyles={"report-setup-type-title"}
            top={null}
          />
          <div style={{ width: "100%" }}>
            {errorDates && (
              <small className="select-error text-danger">
                {messages["reportsMainRT_errorDate"]}
              </small>
            )}
          </div>
        </div>
        <div style={{ paddingTop: 26 }}>
          <label className="title-section-form">
            {messages["dashboardPanel_recent_alerts_type"]}
          </label>
          <Select
            id="alertType"
            label={messages["dashboardPanel_recent_alerts_type_label"]}
            placeholder={messages["dashboardPanel_recent_alerts_type"]}
            loading={loadingCreateEdit}
            options={alertsSupported}
            getOptionLabel={(item) => {
              if (item?.code == "-99") {
                return messages["dashboardPanel_recent_all_alerts_type"];
              }
              const label = messages["alertsNewAlert_" + item.code];
              return label || item.name;
            }}
            textField="name"
            valueField="code"
            isSearchable={false}
            value={formData.alertType}
            onChange={(value) => {
              if (value?.hideUnits) {
                entityTags.hideUnits();
              } else {
                entityTags.showAll();
              }
              setFormData({ ...formData, alertType: value });
            }}
            isClearable
            required
            requiredMessage={messages["required_field"]}
          />
        </div>
        <div style={{ paddingTop: 26, paddingBottom: 300 }}>
          {showEntityTagPicker && (
            <>
              <label className="title-section-form">
                {messages["reportsMainRT_unitDriverSelection"]}
              </label>
              <TagsManage
                data-testid={DASHBOARD_RECENT_ALERTS_TAGS_TEST_ID}
                entities={[
                  { id: "Unit", label: messages["unit_value"] },
                  { id: "Driver", label: messages["drivers"] },
                ]}
                label={messages["dashboardPanel_recent_alerts_view_by"]}
                multiple={true}
                messages={messages}
                value={entityTags?.values}
                onChange={(value) => {
                  entityTags.onChange(value);
                }}
                hideTagsWithoutEntities={true}
                mode="selector"
                isVisiblePill={true}
                menuStyle={{ height: '280px', width: '417px' }}
                entitySelected={entityTags?.entity}
                setEntitySelected={(entity) => {
                  entityTags.onChange([]);
                  setItemsError(false);
                  entityTags.onChangeEntity(entity);
                }}
              />
            </>
          )}

          {itemsError && (
            <small className="select-error text-danger">
              {messages["reportsMainRT_itemsError"]}
            </small>
          )}
        </div>
      </Form>
      <div
        style={{
          backgroundColor: "white",
          bottom: 0,
          position: "fixed",
          padding: 15,
        }}
      >
        <Button
          disabled={loadingCreateEdit}
          className="btn-cancel"
          onClick={(e) => {
            if (e) e.preventDefault();
            handleClose();
          }}
        >
          {messages["cancel"]}
        </Button>
        <Button
          disabled={loadingCreateEdit}
          onClick={(e) => {
            if (e) e.preventDefault();
            setIsSubmit(true);
          }}
          className="btn-blue"
        >
          {messages["save"]}
        </Button>
      </div>
    </div>
  );
};

export default CreateEditRecentAlerts;
